(function () {
  angular.module("akitabox.ui.dialogs.workOrder.detail", [
    "ngMaterial",
    "akitabox.core.services.building",
    "akitabox.core.toast",
  ]);
})();
